export const NEWS_API_ENDPOINTS = {
  ADD_NEWS: "/cms/add-news",
  ADD_NEWS_FILE: "/cms/add-news-file",
  GET_NEWS_DETAILS: "/cms/get-news-details",
  UPDATE_NEWS: "/cms/update-news",
}

export interface NewsDetail {
  title: string;
  shorText: string;
  text: string;
  imageUrl: File | null;
  smallImageUrl: File | null;
  mobileImageUrl: File | null;
  mobileSmallImageUrl: File | null;
  culture: string;
}

export interface DefaultImageList {
  [key: string]: File | null;
  imageUrl: File | null;
  smallImageUrl: File | null;
  mobileImageUrl: File | null;
  mobileSmallImageUrl: File | null;
}

export interface NewsData {
  releaseDate: string;
  isVisible: boolean;
  displayOrder: number | undefined;
  activeSameImages: boolean;
  newsDetail: NewsDetail[];
  newsId?: string;
}

export const defaultImageListData: DefaultImageList[] = [
  {
    imageUrl: null,
    smallImageUrl: null,
    mobileImageUrl: null,
    mobileSmallImageUrl: null
  },
  {
    imageUrl: null,
    smallImageUrl: null,
    mobileImageUrl: null,
    mobileSmallImageUrl: null
  }
];


export const defaultNewsData: NewsData = {
  releaseDate: "",
  isVisible: false,
  displayOrder: undefined,
  activeSameImages: false,
  newsDetail: [
    {
      title: "",
      shorText: "",
      text: "",
      imageUrl: null,
      smallImageUrl: null,
      mobileImageUrl: null,
      mobileSmallImageUrl: null,
      culture: "tr-TR"
    },
    {
      title: "",
      shorText: "",
      text: "",
      imageUrl: null,
      smallImageUrl: null,
      mobileImageUrl: null,
      mobileSmallImageUrl: null,
      culture: "en-US"
    }
  ]
};
